import '../dashboards/dashboard_results/dashboard_preview_results_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.SocialContentContextView extends Monitoring.Views.DashboardPreviewResultsView
  template: JST['backbone/templates/monitoring/social_contents/social_content_context']

  @for: (socialContent, contentLink) ->
    if socialContent.subType() in ['tweet', 'retweet', 'direct-message', 'quote']
      new Monitoring.Views.TwitterContentContextView { socialContent, contentLink }
    else if socialContent.subType() in ['ig-comment', 'ig-comment-live', 'ig-image', 'ig-video', 'ig-live']
      new Monitoring.Views.InstagramContentContextView { socialContent, contentLink }
    else if socialContent.subType() == 'ig-message'
      new Monitoring.Views.InstagramMessageContextView { socialContent, contentLink }
    else if socialContent.subType() in ['fb-comment', 'fb-post']
      new Monitoring.Views.FacebookContentContextView { socialContent, contentLink }
    else if socialContent.type().match('Disqus')
      new Monitoring.Views.DisqusContentContextView { socialContent, contentLink }
    else if socialContent.subType() in [
      Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewContent.SUB_TYPE,
      Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReplyContent.SUB_TYPE
    ]
      new Monitoring.Views.GoogleMyBusinessContentContextView {socialContent, contentLink}
    else if socialContent.subType() in ['yt-comment']
      new Monitoring.Views.YoutubeContentContextView { socialContent, contentLink }
    else if socialContent.type() == 'tiktok'
      new Monitoring.Views.TikTokContentContextView { socialContent, contentLink }
    else
      new Monitoring.Views.SocialContentContextView { socialContent, contentLink }

  initialize: (@options = {}) ->
    super(@options)
    @socialContent = @options.socialContent
    @rootParentId = @socialContent.getRootParentId()
    @immediateParentId = @socialContent.getImmediateParentId()
    @externalLink = @options.contentLink || @socialContentLink() || ''

  socialContentLink: ->
    return @socialContent.link() if @socialContent.link && @socialContent.link()
    return @socialContent.contentUrl() if @socialContent.contentUrl && @socialContent.contentUrl()

  show: ->
    @$el.find('#social-content-context').modal()

  fetchContext: (buildQuery) =>
    buildQuery()
    @$resultsContainer.empty().addClass('processing')
    @searchWith('context', false)

  fetch: =>
    @fetchContext(@buildQuery)

  formatResults: ->
    @$resultsContainer.find('.modal').remove()
    @toggleBlockAll()
    @$resultsContainer.find('section').show() # when is this hidden??
    @moveDateUnderUsername()

  moveDateUnderUsername: ->
    contents = @$resultsContainer.find('section')
    contents.each( (i, content) ->
      dateContainer = $(content).find('.attributes')
      dateContainer.find('.timestamp').text(dateContainer.find('.timestamp').data('original-title'))
      $(content).find('div.tweet-top').append(dateContainer)
    )

  addContextLimit: =>
    @searchQuery.addContextLimit(5)

  toggleBlockAll: ->
    elementsToBlock = [
      '.sc-links'
      '.sc-actions'
      '.sc-sentiment'
      '.sc-selector'
      '.tag'
    ].join(',')
    @$el.find(elementsToBlock).addClass 'unclickable'

  moreContextLinkHtml: ->
    '<div class="more-context"><a target="_blank" href="' + @externalLink + '" title="Browse in ' + _.str.humanize(@socialContent.socialNetworkName()) + '"><i class="context-icon fa fa-ellipsis-h"></i></a></div>'
